// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Battle__PlayersEditFormController from "./battle/players_edit_form_controller"
application.register("battle--players-edit-form", Battle__PlayersEditFormController)

import Battle__TeamFormController from "./battle/team_form_controller"
application.register("battle--team-form", Battle__TeamFormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import Lobby__TeamFormController from "./lobby/team_form_controller"
application.register("lobby--team-form", Lobby__TeamFormController)
application.register("lobby--player-form", Lobby__TeamFormController)
